import { api } from './base';

import { MutationArg } from 'v2/types';
import { DistributionLinkModel } from 'v2/types/DistributionLinkModel';
import { SWRKeyValue } from 'v2/types/swr';

export const distributionLinksService = {
  getDistributionLinks(): Promise<DistributionLinkModel[]> {
    return api('v1/admin/distribution-link').json();
  },

  createDistributionLink(
    _key: string,
    { arg }: MutationArg<Omit<DistributionLinkModel, 'id' | 'isActive' | 'url'>>
  ): Promise<DistributionLinkModel> {
    return api.post('v1/admin/distribution-link', { json: arg }).json();
  },

  updateDistributionLink(
    [_key, linkId]: SWRKeyValue,
    { arg }: MutationArg<Omit<DistributionLinkModel, 'id' | 'url'>>
  ): Promise<DistributionLinkModel> {
    return api.put(`v1/admin/distribution-link/${linkId}`, { json: arg }).json();
  },

  deleteDistributionLink([_key, linkId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/distribution-link/${linkId}`).json();
  },
};
